import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import BeefBracketVoteTallyScore from './BeefBracketVoteTallyScore';
import BeefBracketVoteTallyOtherContenders from './BeefBracketVoteTallyOtherContenders';
import Loader from '../Utility/Loader.js';
import { AJAX_URL } from '../../config/index.js';
import { set } from 'lodash';

export default function BeefBracketVoteTallyApp() {
  const [scoreOneObject, setScoreOneObject] = useState({});
  const [scoreTwoObject, setScoreTwoObject] = useState({});
  const [view, setView] = useState('regular-screen');
  const [showNotice, setShowNotice] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [winningContender, setWinningContender] = useState(null);
  const [footerChecked, setFooterChecked] = useState(false);
  const [currentVoteCountOne, setCurrentVoteCountOne] = useState(null);
  const [currentVoteCountTwo, setCurrentVoteCountTwo] = useState(null);
  const [useSmallFont, setUseSmallFont] = useState(false);
  const [championshipView, setChampionshipView] = useState(false);
  const [otherContenders, setOtherContenders] = useState([]);

  useEffect(() => {
    updatedVoteCount(true);
  }, []);

  // Get updated vote counts every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!championshipView) {
        updatedVoteCount(false);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [currentVoteCountOne, currentVoteCountTwo, championshipView]);

  const updatedVoteCount = (initial) => {
    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}wl_get_beef_bracket_vote_tally`,
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then((res) => {
        if (initial) {
          setScoreOneObject(res.data.contender_one);
          setScoreTwoObject(res.data.contender_two);
          determineWinningContender(
            res.data.contender_one,
            res.data.contender_two
          );

          setCurrentVoteCountOne(res.data.contender_one.voteCount);
          setCurrentVoteCountTwo(res.data.contender_two.voteCount);

          // Check if other contenders exist
          if (
            res.data.other_contenders &&
            res.data.other_contenders.length > 0
          ) {
            setOtherContenders(res.data.other_contenders);
            setChampionshipView(true);
          }

          // Check if either contender has more than 999 votes
          if (
            res.data.contender_one.voteCount > 999 ||
            res.data.contender_two.voteCount > 999
          ) {
            setUseSmallFont(true);
          } else {
            setUseSmallFont(false);
          }

          // Check if the bottom of the footer is higher than the viewport
          if (!footerChecked) {
            setTimeout(() => {
              updateStickyFooter();
              document.body.classList.add('footer-fade-in');
            }, 250);
          }
        } else {
          const prevCount1 = currentVoteCountOne;
          const prevCount2 = currentVoteCountTwo;

          const nextCount1 = res.data.contender_one.voteCount;
          const nextCount2 = res.data.contender_two.voteCount;

          if (prevCount1 !== nextCount1 || prevCount2 !== nextCount2) {
            setShowNotice(true);
            setLoading(true);
            setScoreOneObject((prev) => ({
              ...prev,
              voteCount: res.data.contender_one.voteCount
            }));
            setScoreTwoObject((prev) => ({
              ...prev,
              voteCount: res.data.contender_two.voteCount
            }));
            determineWinningContender(
              res.data.contender_one,
              res.data.contender_two
            );
            setCurrentVoteCountOne(res.data.contender_one.voteCount);
            setCurrentVoteCountTwo(res.data.contender_two.voteCount);

            // Check if either contender has more than 999 votes
            if (
              res.data.contender_one.voteCount > 999 ||
              res.data.contender_two.voteCount > 999
            ) {
              setUseSmallFont(true);
            } else {
              setUseSmallFont(false);
            }

            setTimeout(() => {
              setLoading(false);
            }, 1500);
          }
        }
      })
      .catch((err) => console.log(err.message));
  };

  // Trigger updateStickyFooter() if viewport height changes
  useEffect(() => {
    const handleResize = () => {
      updateStickyFooter();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      setFooterChecked(false);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Update sticky footer based on viewport height
  const updateStickyFooter = () => {
    const footer = document.querySelector('footer');
    if (footer) {
      const footerheightOnPage = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footerheightOnPage.bottom < viewportHeight) {
        document.body.classList.add('footer-higher-than-viewport');
      } else {
        document.body.classList.remove('footer-higher-than-viewport');
      }
    }
  };

  // Determine the winning contender based on the vote counts
  const determineWinningContender = (data1, data2) => {
    if (data1.voteCount > data2.voteCount) {
      setWinningContender(data1.title);
    } else if (data2.voteCount > data1.voteCount) {
      setWinningContender(data2.title);
    } else {
      setWinningContender(null); // It's a tie
    }
  };

  return (
    <>
      <div
        className={`beef-bracket-tally-app ${view} ${
          championshipView ? 'championship-view' : ''
        }`}
      >
        <div className="beef-bracket-header">
          <div className="beef-bracket-mobile-logo">
            <div className="beef-bracket-vote-tally-vs-logo"></div>
          </div>
          <div className="beef-bracket-title">
            <h1 className="title">THE BEEF LOVING TEXANS BOWL</h1>
          </div>
          <div className="beef-bracket-subtitle">
            <div className="subtitle">
              <h2>THREE WEEKS</h2>
              <span className="star-icon"></span>
              <h2>FOUR DISHES</h2>
              <span className="star-icon"></span>
              <h2>ONE CHAMPION</h2>
            </div>
          </div>
        </div>
        {championshipView && (
          <div className="beef-bracket-vote-cast-text u--display-none-xl-min u--margin-bottom-30">
            <span className="md">You Voted</span>
            <span className="sm">For Your</span>
            <span className="lg">MVP</span>
          </div>
        )}
        <div className="beef-bracket-vote-tally-container">
          {!championshipView && (
            <div className="beef-bracket-vote-tally">
              <BeefBracketVoteTallyScore
                view={view}
                scoreObject={scoreOneObject}
                setScoreObject={setScoreOneObject}
                isLoading={isLoading}
                winningContender={winningContender}
                useSmallFont={useSmallFont}
                championshipView={championshipView}
                otherContenders={otherContenders}
              />
            </div>
          )}
          {championshipView && (
            <div className="beef-bracket-vote-tally-other-contenders">
              <BeefBracketVoteTallyOtherContenders
                view={view}
                otherContenders={otherContenders}
                scoreObject={scoreOneObject}
                setScoreObject={setScoreOneObject}
              />
            </div>
          )}
          <div className="beef-bracket-vote-tally-vs-column">
            {championshipView && (
              <div className="beef-bracket-vote-cast-text u--display-none-lg-max">
                <span className="md">You Voted</span>
                <span className="sm">For Your</span>
                <span className="lg">MVP</span>
              </div>
            )}
            {!championshipView && (
              <div className="beef-bracket-vote-tally-vs-logo"></div>
            )}
            <div className="beef-bracket-vote-tally-vs-icon">
              <div className="beef-bracket-vote-tally-vs-icon-inner">
                <span className="vs-icon">VS</span>
              </div>
            </div>
            {championshipView && (
              <div className="beef-bracket-vote-tally-vs-logo u--display-none-lg-max"></div>
            )}
            {!championshipView && (
              <div className="beef-bracket-vote-tally-vs-button">
                <a
                  href="/beef-bowl"
                  className="btn btn-block wlTrackClick"
                  data-wl-label="Beef Bracket Vote Now From Tally"
                  data-wl-event="beef-bracket-vote-now-from-tally-clicked"
                >
                  Vote Now
                </a>
              </div>
            )}
          </div>
          <div className="beef-bracket-vote-tally">
            <BeefBracketVoteTallyScore
              view={view}
              scoreObject={scoreTwoObject}
              setScoreObject={setScoreTwoObject}
              isLoading={isLoading}
              winningContender={winningContender}
              useSmallFont={useSmallFont}
              championshipView={championshipView}
              otherContenders={otherContenders}
            />
          </div>
        </div>
        {!championshipView && (
          <div className="mobile-vote-button">
            <div className="beef-bracket-vote-tally-vs-button">
              <a href="/beef-bowl" className="btn">
                Vote Now
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
